import { createSamlRouter } from "@masteryprep/authprovider"
import { store } from "../../../mp-core/redux/store"
import { firebaseAuth, db } from "../../../mp-database/firebaseConfig"
import { authingUserSuccess } from "../../../mp-core/redux/modules/users"
import { logLogin } from "../../../mp-client/Auth"
import { MpLoader } from "../../../mp-shared-components/ready-shared-components/components/mpLoader"
import {
  EventCategory,
  EventAction,
  EventLabel
} from "../../../mp-utils/generic-utils"
import {
  generateEventMetadata,
  faLogEvent
} from "../../../mp-utils/generic-utils/Events/helpers"
import {
  trackEvent,
  trackSessionStart
} from "../../../mp-utils/generic-utils/Events/eventService"
import { removeAllImpersonationKeys } from "../../../mp-core/Impersonation"

const logEventViaTrackEvent = (
  category: string,
  action: string,
  label: string,
  params: Record<string, unknown> = {}
) => {
  faLogEvent(
    category as EventCategory,
    action as EventAction,
    label as EventLabel,
    params
  )

  trackEvent(
    {
      type: action as EventAction,
      category: category as EventCategory,
      label: label as EventLabel,
      meta: params
    },
    "fa"
  )
}

export default createSamlRouter({
  auth: {
    signInWithCustomToken: token =>
      firebaseAuth()
        .signInWithCustomToken(token)
        .then(() => {}),
    getUserProfile: async (role, id) => {
      const doc = await db
        .collection(role === "Student" ? "students" : "educators")
        .doc(id)
        .get()
      return doc.exists ? doc.data() : null
    }
  },
  state: {
    onAuthSuccess: user => store.dispatch(authingUserSuccess(user))
  },
  analytics: {
    logLogin,
    logSessionStart: trackSessionStart,
    logEvent: logEventViaTrackEvent,
    generateEventMetadata,
    categories: { AUTH: EventCategory.AUTH, SAML: EventCategory.SAML },
    actions: { LOGIN: EventAction.LOGIN },
    labels: {
      SUCCESS: EventLabel.SUCCESS,
      REPORTING: EventLabel.REPORTING,
      ERROR: EventLabel.ERROR,
      SAML: EventLabel.SAML
    }
  },
  components: { LoaderComponent: MpLoader },
  navigation: { redirectToLogin: () => window.location.replace("/login") },
  options: { removeImpersonationKeys: removeAllImpersonationKeys }
})
